import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AurCardGrid from '../../../common/aur-card-grid/AurCardGrid';
import AurAnimatedCard from '../../../common/aur-animated-card/AurAnimatedCard';

interface CardData {
  cardTitle: string;
}

const MyCard: React.FC<CardData> = ({ cardTitle }) => {
  return (
    <AurAnimatedCard>
      <div>{cardTitle}</div>
    </AurAnimatedCard>
  );
};

const CardGrid: React.FC = () => {
  const myData = [
    {
      cardTitle: 'Hello 1',
    },
    {
      cardTitle: 'Hello 2',
    },
    {
      cardTitle: 'Hello 3',
    },
    {
      cardTitle: 'Hello 4',
    },
    {
      cardTitle: 'Hello 5',
    },
    {
      cardTitle: 'Hello 6',
    },
    {
      cardTitle: 'Hello 7',
    },
    {
      cardTitle: 'Hello 8',
    },
    {
      cardTitle: 'Hello 9',
    },
    {
      cardTitle: 'Hello 10',
    },
    {
      cardTitle: 'Hello 11',
    },
    {
      cardTitle: 'Hello 12',
    },
    {
      cardTitle: 'Hello 13',
    },
    {
      cardTitle: 'Hello 14',
    },
    {
      cardTitle: 'Hello 15',
    },
  ];

  const [data] = useState<CardData[]>(myData);
  const [currentPageCard, setCurrentPageCard] = useState<number>(1);
  const [itemsPerPageCard, setItemsPerPageCard] = useState<number>(12);

  return (
    <>
      <div style={{ marginBottom: '64px' }}>
        <h1>Card Grid</h1>
        The Card Grid presents information in a structured format of rows and
        columns. The data is displayed in a user-friendly interface for quick
        reviewing.
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{ marginBottom: '32px' }}>
          <AurCardGrid
            rows={data}
            pageSizeOptions={[12, 24, 36]}
            entityType={'cards'}
            CardComponent={MyCard}
            currentPage={currentPageCard}
            setCurrentPage={setCurrentPageCard}
            itemsPerPage={itemsPerPageCard}
            setItemsPerPage={setItemsPerPageCard}
          />
        </div>
      </div>
    </>
  );
};

export default CardGrid;
